export default __webpack_public_path__ + "static/media/risk_level_3.e0b2e5cc.png";